module.exports = __webpack_public_path__ + "4a8482215e3ff690b262a87545d5f289.svg";